var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountCardDetails = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.5 7.2h11c.577 0 1.1.506 1.1 1.066v7.467c0 .56-.523 1.067-1.1 1.067h-11c-.578 0-1.1-.507-1.1-1.067V8.266c0-.56.522-1.066 1.1-1.066m6.6 1.6v.533h4.4V8.8zm0 1.066v.534h4.4v-.534zm0 1.067v.533h3.85v-.533zm-3.3 2.085c-1.1 0-3.3.582-3.3 1.648v.534h6.6v-.534c0-1.066-2.2-1.648-3.3-1.648m0-4.218c-.438 0-.857.168-1.167.468s-.483.707-.483 1.132.174.831.483 1.131c.31.3.73.469 1.167.469s.857-.169 1.167-.469.483-.707.483-1.131-.174-.832-.483-1.132c-.31-.3-.73-.468-1.167-.468"
})));
export default SvgAccountCardDetails;